import { Modal, Form, Button } from "react-bootstrap";
import toastService from "../../_services/toastService";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function RemoveModal({ data = {}, hideModal }) {
  const onFormSubmit = async e => {
    e.preventDefault();
    try {
      await api.deleteAcademicYear(data.id);
      toastService.send({ title: "Verwijderd", message: "Academiejaar verwijderd" });
      hideModal();
    } catch (error) {
      toastService.send({ title: "Fout", message: `${error.message ?? error}` });
    }
  };

  return (
    <Modal show onHide={hideModal} backdrop="static" keyboard={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Academiejaar verwijderen?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onFormSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>
              Ben je zeker dat je <strong>{data.year}</strong> wilt verwijderen?
            </Form.Label>
          </Form.Group>
          <Button variant="danger" type="submit">
            <i className="far fa-trash" />&nbsp;Verwijder
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default RemoveModal;
